import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { FilterDropdownButton } from '../filters-dropdown/FilterDropdownButton';
import { CustomDropdown } from '../../../../components/custom-dropdown/CustomDropdown';
import { FilterDropdownBox } from '../filters-dropdown/FilterDropdownBox';
import { FilterDropdown } from '../filters-dropdown/FilterDropdown';
import { searchConstants } from '../../../search-utils/searchConstants';
import { Categories } from '../../aside-filters/categories/Categories';
import { CategoryEnum } from '../../../search.types';
import styles from './search_filters_categories.module.scss';
import { FilterDropdownHeader } from '../filters-dropdown/FilterDropdownHeader';

type Props = {
  type: CategoryEnum;
  isSelected: boolean;
  count: number;
  track: Function;
  position?: number;
  searchType: 'arret' | 'law' | 'commentary';
};

export const SearchFiltersCategory: FC<Props> = ({
  type,
  isSelected,
  count,
  track,
  position,
}) => {
  function onClick(toggle: Function, value: boolean) {
    return () => {
      track(type, value);
      toggle();
    };
  }

  return (
    <CustomDropdown>
      {(isOpen, toggle) => (
        <FilterDropdown>
          <FilterDropdownButton
            uppercase
            isSelected={isSelected}
            onClick={onClick(toggle, !isOpen)}
          >
            <FormattedMessage id={searchConstants.filters[type]} />
            {count > 0 && (
              <span>
                {'\u00A0'}({count})
              </span>
            )}
          </FilterDropdownButton>
          {isOpen && (
            <FilterDropdownBox style={{ left: position }}>
              <FilterDropdownHeader
                onClick={
                  toggle as (
                    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
                  ) => void
                }
                title={<FormattedMessage id={searchConstants.filters[type]} />}
              />
              <div className={styles.container}>
                <Categories
                  type={type}
                  displayedItemCount={Number.MAX_SAFE_INTEGER}
                />
              </div>
            </FilterDropdownBox>
          )}
        </FilterDropdown>
      )}
    </CustomDropdown>
  );
};
